import { z } from 'zod';

export const SChatwootStandardMessage = z.object({
  identifier: z.string(),
  message: z
    .object({
      event: z.string(),
      data: z.any(),
    })
    .optional(),
});
export type TChatwootStandardMessage = z.infer<typeof SChatwootStandardMessage>;
